import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";

const day = (iso) => new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export const PainChart = ({ checkins, height = 200, testid = "pain-chart", emptyText = "No check-ins yet — your progress will show here." }) => {
  if (!checkins?.length) return <p className="text-sm text-slate-400" data-testid={`${testid}-empty`}>{emptyText}</p>;
  const data = checkins.map((c) => ({ date: day(c.created_at), pain: c.pain }));
  return (
    <div style={{ height }} data-testid={testid}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 12, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#64748b" }} tickFormatter={(v) => v.split(",")[0]} />
          <YAxis domain={[0, 10]} ticks={[0, 2, 4, 6, 8, 10]} tick={{ fontSize: 11, fill: "#64748b" }} />
          <Tooltip formatter={(v) => [`${v}/10`, "Pain"]} />
          <Line type="monotone" dataKey="pain" stroke="#0D9488" strokeWidth={2.5} dot={{ r: 4 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
